(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="locale_code"], input[name="country_code"]'
      ),
      button: this.querySelector("button"),
      panel: this.querySelector("ul"),
    };

    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.elements.button.addEventListener("click", this.togglePanel.bind(this));
    this.addEventListener("keydown", this.onEscapePress.bind(this));

    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
  }

  connectedCallback() {
    document.addEventListener("click", this.handleDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.handleDocumentClick);
  }

  handleDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.hidePanel();
    }
  }

  hidePanel() {
    this.elements.button.setAttribute("aria-expanded", "false");
    this.elements.panel.setAttribute("hidden", true);
  }

  showPanel() {
    this.elements.button.setAttribute("aria-expanded", "true");
    this.elements.panel.removeAttribute("hidden");
  }

  togglePanel() {
    if (this.elements.button.getAttribute("aria-expanded") === "true") {
      this.hidePanel();
    } else {
      this.showPanel();
    }
  }

  onEscapePress(event) {
    if (event.key === "Escape") {
      this.hidePanel();
    }
  }

  onItemClick(event) {
    event.preventDefault();
    this.elements.input.value = event.currentTarget.dataset.value;
    this.querySelector("form")?.submit();
    this.hidePanel();
  }
}

if (!customElements.get("localization-form")) {
  customElements.define("localization-form", LocalizationForm);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerInner = document.querySelector('.header');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
		
		if (this.headerIsAlwaysSticky) this.reveal; 
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.style.transition = 'background var(--duration-short), transform var(--duration-default)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		//if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations--single');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  class LeverandorSku extends HTMLElement {
    constructor() {
      super();
      try {
        const dataEl = this.querySelector('script[data-lev-data]');
        this.variantData = dataEl ? JSON.parse(dataEl.textContent) : {};
      } catch (e) {
        this.variantData = {};
      }
      this.displayMode = this.dataset.displayMode || 'per_row';
      this.sharedLabel = this.dataset.sharedLabel || '';
      this.separator = this.dataset.separator || ', ';
      this.sectionId = this.dataset.section;
      this._lastVariantId = null;

      this._onChange = this._onChange.bind(this);
      this._onClick = this._onClick.bind(this);
      this._poll = this._poll.bind(this);
    }

    connectedCallback() {
      // Listen at document level so we catch events even if scope detection fails
      document.addEventListener('change', this._onChange, true);
      document.addEventListener('click', this._onClick, true);

      // Capture the initial variant id so we can detect changes
      const idInput = this._findIdInput();
      if (idInput) this._lastVariantId = idInput.value;
    }

    disconnectedCallback() {
      document.removeEventListener('change', this._onChange, true);
      document.removeEventListener('click', this._onClick, true);
    }

    _findIdInput() {
      // Find the variant id input belonging to this section. Try a few selectors.
      const productForm =
        document.querySelector('product-form[data-source="' + this.sectionId + '"]') ||
        document.getElementById('ProductInfo-' + this.sectionId) ||
        document.getElementById('MainProduct-' + this.sectionId);
      if (!productForm) return null;
      return productForm.querySelector('input[name="id"]') || productForm.querySelector('select[name="id"]');
    }

    _isInThisSection(el) {
      if (!el || !el.closest) return false;
      const root =
        document.getElementById('MainProduct-' + this.sectionId) ||
        document.querySelector('[data-section="' + this.sectionId + '"]');
      return root ? root.contains(el) : true;
    }

    _onChange(event) {
      const target = event.target;
      if (!target || !target.matches) return;
      if (!target.matches('input[type="radio"], input[name^="options"], select[name^="options"], select[name="id"]')) return;
      if (!this._isInThisSection(target)) return;
      this._poll();
    }

    _onClick(event) {
      const target = event.target;
      if (!target || !target.closest) return;
      // Catch label clicks for radio-style variant pickers
      const label = target.closest('label');
      if (!label) return;
      if (!this._isInThisSection(label)) return;
      // Only react if the label is associated with a variant input
      const forId = label.getAttribute('for');
      const input = forId ? document.getElementById(forId) : label.querySelector('input');
      if (!input) return;
      if (!input.matches('input[type="radio"], input[name^="options"]')) return;
      this._poll();
    }

    _poll() {
      // The form's hidden id input may not be updated synchronously — poll briefly.
      let attempts = 0;
      const maxAttempts = 30; // ~1.5s total
      const tick = () => {
        const idInput = this._findIdInput();
        const currentId = idInput ? idInput.value : null;
        if (currentId && currentId !== this._lastVariantId) {
          this._lastVariantId = currentId;
          this._render(this.variantData[currentId] || []);
          return;
        }
        attempts += 1;
        if (attempts < maxAttempts) {
          setTimeout(tick, 50);
        }
      };
      setTimeout(tick, 0);
    }

    _render(entries) {
      // Remove existing rendered lines
      this.querySelectorAll('[data-lev-line]').forEach(el => el.remove());

      if (!entries.length) {
        this.classList.add('hidden');
        return;
      }
      this.classList.remove('hidden');

      const dataEl = this.querySelector('script[data-lev-data]');

      if (this.displayMode === 'shared') {
        const p = document.createElement('p');
        p.className = 'product__sku';
        p.setAttribute('data-lev-line', '');
        if (this.sharedLabel) {
          const titleSpan = document.createElement('span');
          titleSpan.className = 'product__sku-title';
          titleSpan.textContent = this.sharedLabel + ': ';
          p.appendChild(titleSpan);
        }
        const valuesSpan = document.createElement('span');
        valuesSpan.setAttribute('data-lev-values', '');
        valuesSpan.textContent = entries.map(e => e.value).join(this.separator);
        p.appendChild(valuesSpan);
        this.insertBefore(p, dataEl);
      } else {
        entries.forEach(entry => {
          const p = document.createElement('p');
          p.className = 'product__sku';
          p.setAttribute('data-lev-line', '');
          const titleSpan = document.createElement('span');
          titleSpan.className = 'product__sku-title';
          titleSpan.textContent = entry.label + ': ';
          const valueSpan = document.createElement('span');
          valueSpan.setAttribute('data-lev-value', '');
          valueSpan.textContent = entry.value;
          p.appendChild(titleSpan);
          p.appendChild(valueSpan);
          this.insertBefore(p, dataEl);
        });
      }
    }
  }

  class PriceRunnerBadge extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.section;
      this.merchant  = this.dataset.merchant;
      this.market    = this.dataset.market;
      this.lang      = this.dataset.lang;
      this.width     = parseInt(this.dataset.width, 10) || 200;
      try {
        const dataEl = this.querySelector('script[data-pr-variants]');
        this.skus = dataEl ? JSON.parse(dataEl.textContent) : {};
      } catch (e) {
        this.skus = {};
      }
      this._lastVariantId = null;
      this._onChange = this._onChange.bind(this);
      this._onClick  = this._onClick.bind(this);
      this._poll     = this._poll.bind(this);
    }

    connectedCallback() {
      document.addEventListener('change', this._onChange, true);
      document.addEventListener('click',  this._onClick,  true);
      const idInput = this._findIdInput();
      if (idInput) this._lastVariantId = idInput.value;
    }

    disconnectedCallback() {
      document.removeEventListener('change', this._onChange, true);
      document.removeEventListener('click',  this._onClick,  true);
    }

    _findIdInput() {
      const productForm =
        document.querySelector('product-form[data-source="' + this.sectionId + '"]') ||
        document.getElementById('ProductInfo-' + this.sectionId) ||
        document.getElementById('MainProduct-' + this.sectionId);
      if (!productForm) return null;
      return productForm.querySelector('input[name="id"]') || productForm.querySelector('select[name="id"]');
    }

    _isInThisSection(el) {
      if (!el || !el.closest) return false;
      const root =
        document.getElementById('MainProduct-' + this.sectionId) ||
        document.querySelector('[data-section="' + this.sectionId + '"]');
      return root ? root.contains(el) : true;
    }

    _onChange(event) {
      const target = event.target;
      if (!target || !target.matches) return;
      if (!target.matches('input[type="radio"], input[name^="options"], select[name^="options"], select[name="id"]')) return;
      if (!this._isInThisSection(target)) return;
      this._poll();
    }

    _onClick(event) {
      const target = event.target;
      if (!target || !target.closest) return;
      const label = target.closest('label');
      if (!label) return;
      if (!this._isInThisSection(label)) return;
      const forId = label.getAttribute('for');
      const input = forId ? document.getElementById(forId) : label.querySelector('input');
      if (!input) return;
      if (!input.matches('input[type="radio"], input[name^="options"]')) return;
      this._poll();
    }

    _poll() {
      let attempts = 0;
      const maxAttempts = 30;
      const tick = () => {
        const idInput = this._findIdInput();
        const currentId = idInput ? idInput.value : null;
        if (currentId && currentId !== this._lastVariantId) {
          this._lastVariantId = currentId;
          const sku = this.skus[currentId];
          this._render(sku);
          return;
        }
        attempts += 1;
        if (attempts < maxAttempts) {
          setTimeout(tick, 50);
        }
      };
      setTimeout(tick, 0);
    }

    _render(sku) {
      if (!sku) {
        this.classList.add('hidden');
        return;
      }

      const enc       = encodeURIComponent(sku);
      const base      = 'https://api.pricerunner.com/widget/cheapest';
      const imgSrc    = `${base}/image/${this.merchant}?sku=${enc}&market=${this.market}&lang=${this.lang}&width=${this.width}`;
      const imgSrcset = `${base}/image/${this.merchant}?sku=${enc}&market=${this.market}&lang=${this.lang}&width=${this.width * 2} 2x`;
      const linkHref  = `${base}/backlink/${this.merchant}?sku=${enc}`;

      let link = this.querySelector('[data-pr-link]');
      let img  = this.querySelector('[data-pr-img]');

      if (!link) {
        // Initially rendered without anchor (variant had no SKU) — build it now
        link = document.createElement('a');
        link.setAttribute('aria-hidden', 'true');
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener');
        link.setAttribute('data-pr-link', '');
        img = document.createElement('img');
        img.setAttribute('alt', 'Laveste pris på PriceRunner');
        img.setAttribute('loading', 'lazy');
        img.setAttribute('data-pr-img', '');
        link.appendChild(img);
        this.insertBefore(link, this.firstChild);
      }

      link.href = linkHref;
      img.src = imgSrc;
      img.srcset = imgSrcset;
      this.dataset.currentSku = sku;
      this.classList.remove('hidden');
    }
  }

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations--single', ProductRecommendations);
  customElements.define('leverandor-sku', LeverandorSku);
  customElements.define('pricerunner-badge', PriceRunnerBadge);

  } catch(e) { console.error(e); }
})();
})();
